import { render, staticRenderFns } from "./GoodsManage.vue?vue&type=template&id=ff072022&scoped=true"
import script from "./GoodsManage.vue?vue&type=script&lang=js"
export * from "./GoodsManage.vue?vue&type=script&lang=js"
import style0 from "./GoodsManage.vue?vue&type=style&index=0&id=ff072022&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff072022",
  null
  
)

export default component.exports